import { type ButtonProps } from '@carvana/showroom-forms/Button/Base/Button';
import Primary from '@carvana/showroom-forms/Button/Primary';
import Secondary from '@carvana/showroom-forms/Button/Secondary';
import Tertiary from '@carvana/showroom-forms/Button/Tertiary';
import { createComponent } from '@carvana/vdp-components';

export const PrimaryButton = createComponent<ButtonProps>(Primary, {
  className: '!min-w-[160px]'
});

export const SecondaryButton = createComponent<ButtonProps>(Secondary, {
  className: '!min-w-[160px]'
});

export const TertiaryButton = createComponent<ButtonProps>(Tertiary, {
  className: '!min-w-[160px]'
});
